import React, { useState, useEffect, useRef } from "react";
import "./HomePage.css";
import encipherxLogo from "../img/encipherx-enhanced.svg";
import digitalAntenna from "../img/digital-antenna.svg";
import finalImage from "../img/Final.png";
import alteredSecurityLogo from "../img/Altered_security.webp";
import apisecLogo from "../img/apisec-logo.png";
import caidoLogo from "../img/caido.webp";
import hackersMeetupLogo from "../img/The _Hackers_Meetup_Nagpur.png";
import cyberxLogo from "../img/CyberX.jpeg";
import modernSecurityLogo from "../img/ModernSecurity.jpeg";
import enciphersLogo from "../img/Enciphers.png";
import ecCouncilLogo from "../img/ec-council.jpg";

// TextScramble class
class TextScramble {
  constructor(el) {
    this.el = el;
    this.chars = '!<>-_\\/[]{}—=+*^?#________';
    this.update = this.update.bind(this);
  }
  setText(newText) {
    const oldText = this.el.innerText;
    const length = Math.max(oldText.length, newText.length);
    const promise = new Promise((resolve) => (this.resolve = resolve));
    this.queue = [];
    for (let i = 0; i < length; i++) {
      const from = oldText[i] || '';
      const to = newText[i] || '';
      const start = Math.floor(Math.random() * 40);
      const end = start + Math.floor(Math.random() * 40);
      this.queue.push({ from, to, start, end });
    }
    cancelAnimationFrame(this.frameRequest);
    this.frame = 0;
    this.update();
    return promise;
  }
  update() {
    let output = '';
    let complete = 0;
    for (let i = 0, n = this.queue.length; i < n; i++) {
      let { from, to, start, end, char } = this.queue[i];
      if (this.frame >= end) {
        complete++;
        output += to;
      } else if (this.frame >= start) {
        if (!char || Math.random() < 0.28) {
          char = this.randomChar();
          this.queue[i].char = char;
        }
        output += `<span class="dud">${char}</span>`;
      } else {
        output += from;
      }
    }
    this.el.innerHTML = output;
    if (complete === this.queue.length) {
      this.resolve();
    } else {
      this.frameRequest = requestAnimationFrame(this.update);
      this.frame++;
    }
  }
  randomChar() {
    return this.chars[Math.floor(Math.random() * this.chars.length)];
  }
}

const HomePage = () => {
  const [activeFilter, setActiveFilter] = useState("ALL");
  const [signalPhase, setSignalPhase] = useState(0); // 0: no signal, 1: first signal, 2: second signal
  const [showMessage, setShowMessage] = useState(false);
  const encipherxTextRef = useRef(null);

  const filters = [];
  const threatVectors = [];

  // Text scramble animation
  useEffect(() => {
    if (encipherxTextRef.current) {
      const fx = new TextScramble(encipherxTextRef.current);
      const phrases = ['ENCIPHERX 4.0'];
      
      let counter = 0;
      const next = () => {
        fx.setText(phrases[counter]).then(() => {
          // Restart animation after delay
          setTimeout(next, 3000);
        });
        counter = (counter + 1) % phrases.length;
      };
      
      // Start animation
      next();
    }
  }, []);

  // Signal timing logic
  useEffect(() => {
    // First signal after 3 seconds
    const firstSignalTimer = setTimeout(() => {
      setSignalPhase(1);
      setShowMessage(true);
    }, 3000);

    // Hide first message after 5 seconds
    const hideFirstMessageTimer = setTimeout(() => {
      setShowMessage(false);
    }, 8000); // 3s delay + 5s display

    // Second signal after 10 seconds total
    const secondSignalTimer = setTimeout(() => {
      setSignalPhase(2);
      setShowMessage(true);
    }, 10000);

    // Hide second message after 5 seconds
    const hideSecondMessageTimer = setTimeout(() => {
      setShowMessage(false);
    }, 15000); // 10s delay + 5s display

    // Cleanup timers
    return () => {
      clearTimeout(firstSignalTimer);
      clearTimeout(hideFirstMessageTimer);
      clearTimeout(secondSignalTimer);
      clearTimeout(hideSecondMessageTimer);
    };
  }, []);

  return (
    <div className="home-page">
      <div className="military-cyber-background">
        <div className="background-overlay"></div>
        <div className="scanning-lines"></div>
        <div className="data-streams"></div>
        <div className="grid-pattern"></div>
        <div className="operation-status">
          <div className="status-indicator">
            <span className="status-text">OPERATION STATUS: ACTIVE</span>
            <div className="status-pulse"></div>
          </div>
          <div className="mission-clock">
            <span className="clock-label">MISSION DATE</span>
            <div className="clock-display">
              February 7-8, 2026
            </div>
          </div>
        </div>
        <div className="logo-section">
          <div className="logo-container">
            <img
              src={encipherxLogo}
              alt="Encipherx Logo"
              className="encipherx-logo"
            />
            <div className="logo-glow"></div>
          </div>
        </div>

        <div className="antenna-section">
          <img
            src={digitalAntenna}
            alt="Digital Antenna"
            className="digital-antenna"
          />
        </div>

        <div className={`ctf-message ${showMessage ? "visible" : "hidden"}`}>
          <div className="message-container">
            <div className="binary-sequence">
              <span className="binary-digit">1</span>
              <span className="binary-digit">0</span>
              <span className="binary-digit">1</span>
              <span className="binary-digit">1</span>
              <span className="binary-digit">0</span>
              <span className="binary-digit">0</span>
              <span className="binary-digit">1</span>
            </div>
            <div className="message-text">
              {signalPhase === 1 ? "CTF PLAYER REGISTRATION" : "PLAY CTF"}
            </div>
          </div>
        </div>

        <div className="final-image-section">
          <img src={finalImage} alt="Final CTF Image" className="final-image" />
          <div className="encipherx-version-text" ref={encipherxTextRef}>
            ENCIPHERX 4.0
          </div>
        </div>

        <div className="cyber-terminal">
          <div className="terminal-header">
            <span className="terminal-title">
              //PHOENIX CYBERSECURITY TERMINAL
            </span>
            <div className="terminal-controls">
              <span className="control-dot red"></span>
              <span className="control-dot yellow"></span>
              <span className="control-dot green"></span>
            </div>
          </div>
          <div className="terminal-content">
            <div className="terminal-line">
              <span className="prompt">&gt;</span>
              <span className="command">initialize_cyber_defense_protocol</span>
            </div>
            <div className="terminal-line">
              <span className="output">[OK] Firewall systems online</span>
            </div>
            <div className="terminal-line">
              <span className="output">[OK] Intrusion detection active</span>
            </div>
            <div className="terminal-line">
              <span className="output">[OK] Threat analysis running</span>
            </div>
            <div className="terminal-line">
              <span className="prompt">&gt;</span>
              <span className="command blinking">_</span>
            </div>
          </div>
        </div>
      </div>

      <div className="sponsors-carousel-section">
        <h2 className="sponsors-carousel-title">OUR SPONSORS & PARTNERS</h2>
        <div className="sponsors-carousel">
          <div className="sponsors-track">
            <a href="https://www.alteredsecurity.com/" target="_blank" rel="noopener noreferrer" className="sponsor-slide">
              <img src={alteredSecurityLogo} alt="Altered Security" />
            </a>
            <a href="https://www.apisecuniversity.com/" target="_blank" rel="noopener noreferrer" className="sponsor-slide">
              <img src={apisecLogo} alt="APISec University" />
            </a>
            <a href="https://caido.io/" target="_blank" rel="noopener noreferrer" className="sponsor-slide">
              <img src={caidoLogo} alt="Caido" />
            </a>
            <a href="https://www.modernsecurity.io/" target="_blank" rel="noopener noreferrer" className="sponsor-slide">
              <img src={modernSecurityLogo} alt="Modern Security" />
            </a>
            <a href="https://www.enciphers.com/" target="_blank" rel="noopener noreferrer" className="sponsor-slide">
              <img src={enciphersLogo} alt="Enciphers" />
            </a>
            <a href="https://www.eccouncil.org/" target="_blank" rel="noopener noreferrer" className="sponsor-slide">
              <img src={ecCouncilLogo} alt="EC-Council" />
            </a>
            <a href="https://thehackersmeetup.org/" target="_blank" rel="noopener noreferrer" className="sponsor-slide">
              <img src={hackersMeetupLogo} alt="The Hackers Meetup Nagpur" />
            </a>

            <a href="https://www.cyberxindia.com/" target="_blank" rel="noopener noreferrer" className="sponsor-slide">
              <img src={cyberxLogo} alt="CyberX" />
            </a>
            {/* Duplicate for seamless loop */}
            <a href="https://www.alteredsecurity.com/" target="_blank" rel="noopener noreferrer" className="sponsor-slide">
              <img src={alteredSecurityLogo} alt="Altered Security" />
            </a>
            <a href="https://www.apisecuniversity.com/" target="_blank" rel="noopener noreferrer" className="sponsor-slide">
              <img src={apisecLogo} alt="APISec University" />
            </a>
            <a href="https://caido.io/" target="_blank" rel="noopener noreferrer" className="sponsor-slide">
              <img src={caidoLogo} alt="Caido" />
            </a>
            <a href="https://www.modernsecurity.io/" target="_blank" rel="noopener noreferrer" className="sponsor-slide">
              <img src={modernSecurityLogo} alt="Modern Security" />
            </a>
            <a href="https://www.enciphers.com/" target="_blank" rel="noopener noreferrer" className="sponsor-slide">
              <img src={enciphersLogo} alt="Enciphers" />
            </a>
            <a href="https://www.eccouncil.org/" target="_blank" rel="noopener noreferrer" className="sponsor-slide">
              <img src={ecCouncilLogo} alt="EC-Council" />
            </a>
            <a href="https://thehackersmeetup.org/" target="_blank" rel="noopener noreferrer" className="sponsor-slide">
              <img src={hackersMeetupLogo} alt="The Hackers Meetup Nagpur" />
            </a>

            <a href="https://www.cyberxindia.com/" target="_blank" rel="noopener noreferrer" className="sponsor-slide">
              <img src={cyberxLogo} alt="CyberX" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
